import React from 'react';

const GraphIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
         stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
    >
        <rect x="16" y="16" width="6" height="6" rx="1"/>
        <rect x="2" y="16" width="6" height="6" rx="1"/>
        <rect x="9" y="2" width="6" height="6" rx="1"/>
        <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"/>
        <path d="M12 12V8"/>
    </svg>
);

export default GraphIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/GraphIcon.jsx